// src/config.js
export const SITE_CONFIG = {
  ASSISTANT: { ENABLED: true },
  SITE_ID: 'david.hamady.flint',
  LISTING_PREVIEWS_ENABLED: true,
  BASE_URL: 'davidhamady.com',
  STATE: 'MI',
  AMPLIFY_REBUILD_WEBHOOK: 'https://webhooks.amplify.us-east-1.amazonaws.com/prod/webhooks?id=6bb978dd-c4d5-4452-be36-ae8a6f59bb9e&token=ixiHoKkaFXzgK9O6qejl8Mz6CNe0ybDnKojigtKkmBc&operation=startbuild',
  AGENT: {
    MLS_ID: '6501274903',
    NAME: 'David Hamady',
    OFFICE_CITY: 'Flint',
    BROKERAGE: 'HamadyRobinson, REALTORS®',
    EMAIL: 'david@granthamadyrealtors.com',
    PHONE: '(810) 814-0490',
    ZILLOW_REVIEW: 'https://www.zillow.com/reviews/write/?s=X1-ZU135n3kdbbilmx_4dbol',
    GOOGLE_REVIEW: 'https://www.google.com/search?sca_esv=63e1c1c2b01bb700&sxsrf=ANbL-n4crcS_RGusNntjOSqCnVsXTaQglg:1774108517022&si=AL3DRZHrmvnFAVQPOO2Bzhf8AX9KZZ6raUI_dT7DG_z0kV2_x6dQEnVYS5MLxSPx3C6wSijVZgQaDiGxd8IvRMu8gokA_Ns6LzIy1FsbOvagcG6MaS44LeO9o0xwkyoC1sf3HUHjVoUvfZP_FoSO4me3VYC9n9_ydQ%3D%3D&q=HamadyRobinson,+REALTORS%C2%AE+Reviews&sa=X&ved=2ahUKEwjcx8yfrbGTAxVRkmoFHciPKtwQ0bkNegQIRRAH&biw=1920&bih=958&dpr=1#',
    BROKERAGE_LICENSE: '6501274903',
    LICENSE: '6501274903'
  },
  LANDING_PAGE: {
  "VIDEOS": {
    "HERO": "https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/d.hamady.landing.can.002.mp4",
    "HOME_VALUE": "https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic-dining-001.mp4"
  },
  "EDITORIAL_IMAGES": {
    "LIVING_ROOM": "https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic-living-room-002.jpg",
    "CONDO_INTERIOR": "https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic-condo-interior-001.jpg"
  },
  "AGENT_IMAGE": "https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/headshots/david.hamady.flint_62e436a10ae14e62bcdca74224f02663.png",
  "CITY_IMAGES": {
    "FLINT": "https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic_flint_home_001.jpeg",
    "GRAND_BLANC": "https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic_flint_home_002.jpeg",
    "DAVISON": "https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic_flint_home_003.jpeg",
    "BURTON": "https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic_flint_home_001.jpeg",
    "SWARTZ_CREEK": "https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic_flint_home_002.jpeg",
    "FENTON": "https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic_flint_home_003.jpeg"
  },
  "FOOTER_LOGO": "https://aw-business-marketing.s3.us-east-1.amazonaws.com/websitesbyaw-transparent.png"
},
  MLS: {
    NAME: 'East Central Association of REALTOR',
    SHORT_NAME: 'ECAR',
    LOGO_URL: 'https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/logos/ecarlogo.png',
    DISCLAIMER: "IDX information is provided exclusively for consumers' personal, non-commercial use, and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Data is deemed reliable but is not guaranteed accurate by the MLS."
  }
};
